import React from "react";
import { useTranslation } from "react-i18next";
import FormInput from "src/components/Common/Form/FormInput";
import { FORM_NAME, PATTERN_NUMBER } from "src/constant/common";

const AerodynamicSigma = ({ register, errors }) => {
  const { t } = useTranslation("gnc-simulator-6dof");
  return (
    <div className="row">
      <h3 className="mcs-block-title">{t("new.MCS.aerodynamic_sigma_title")}</h3>
      <div className="col-12 width-by-percent-91">
        <div className="d-flex justify-content-between">
          <FormInput
            register={register}
            classGroup="ms-2 w-100"
            label={t(`new.MCS.${FORM_NAME.MCS.CA}`)}
            name={`MCS.${FORM_NAME.MCS.CA}`}
            placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.CA}`) })}
            errors={errors?.MCS?.[FORM_NAME.MCS.CA]?.message}
            requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.CA}`) })}
            required
            pattern={{
              value: PATTERN_NUMBER,
              message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.CA}`) }),
            }}
            maxLength={255}
            maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.CA}`) })}
          />
          <FormInput
            register={register}
            classGroup="ms-2 w-100"
            label={t(`new.MCS.${FORM_NAME.MCS.CY}`)}
            name={`MCS.${FORM_NAME.MCS.CY}`}
            placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.CY}`) })}
            errors={errors?.MCS?.[FORM_NAME.MCS.CY]?.message}
            requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.CY}`) })}
            required
            pattern={{
              value: PATTERN_NUMBER,
              message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.CY}`) }),
            }}
            maxLength={255}
            maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.CY}`) })}
          />
          <FormInput
            register={register}
            classGroup="ms-2 w-100"
            label={t(`new.MCS.${FORM_NAME.MCS.CN}`)}
            name={`MCS.${FORM_NAME.MCS.CN}`}
            placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.CN}`) })}
            errors={errors?.MCS?.[FORM_NAME.MCS.CN]?.message}
            requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.CN}`) })}
            required
            pattern={{
              value: PATTERN_NUMBER,
              message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.CN}`) }),
            }}
            maxLength={255}
            maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.CN}`) })}
          />
        </div>
        <div className="d-flex justify-content-between">
          <FormInput
            register={register}
            classGroup="ms-2 w-100"
            label={t(`new.MCS.${FORM_NAME.MCS.Cl}`)}
            name={`MCS.${FORM_NAME.MCS.Cl}`}
            placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.Cl}`) })}
            errors={errors?.MCS?.[FORM_NAME.MCS.Cl]?.message}
            requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.Cl}`) })}
            required
            pattern={{
              value: PATTERN_NUMBER,
              message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.Cl}`) }),
            }}
            maxLength={255}
            maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.Cl}`) })}
          />
          <FormInput
            register={register}
            classGroup="ms-2 w-100"
            label={t(`new.MCS.${FORM_NAME.MCS.Cm}`)}
            name={`MCS.${FORM_NAME.MCS.Cm}`}
            placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.Cm}`) })}
            errors={errors?.MCS?.[FORM_NAME.MCS.Cm]?.message}
            requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.Cm}`) })}
            required
            pattern={{
              value: PATTERN_NUMBER,
              message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.Cm}`) }),
            }}
            maxLength={255}
            maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.Cm}`) })}
          />
          <FormInput
            register={register}
            classGroup="ms-2 w-100"
            label={t(`new.MCS.${FORM_NAME.MCS.Cn}`)}
            name={`MCS.${FORM_NAME.MCS.Cn}`}
            placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.Cn}`) })}
            errors={errors?.MCS?.[FORM_NAME.MCS.Cn]?.message}
            requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.Cn}`) })}
            required
            pattern={{
              value: PATTERN_NUMBER,
              message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.Cn}`) }),
            }}
            maxLength={255}
            maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.Cn}`) })}
          />
        </div>
      </div>
    </div>
  );
};

export default AerodynamicSigma;
